import { Typography, tokens } from '@beeline.com/bp-design-system';
import React, { FC } from 'react';
import { ClientSupportLink } from 'src/components/pages/settings/userInterfaceSettings/general/clientSupportLinks/types';
import { useTenantAppearance } from 'src/utils/hooks/useTenantAppearance';
import styled from 'styled-components';
import { HeaderAction } from './HeaderAction';

interface Props {
  links: ClientSupportLink[];
  onClick: (label: string, url: string) => void;
}

export const SupportLinks: FC<React.PropsWithChildren<Props>> = ({ links, onClick }) => {
  const { label: clientName } = useTenantAppearance();

  return (
    <>
      <StyledLine />
      <MenuListSubHeader>{clientName}</MenuListSubHeader>
      {links.map((link) => (
        <HeaderAction
          key={link.uid}
          dataTest="client-support-link"
          text={link.title}
          rel="noopener noreferrer"
          target="_blank"
          href={link.url}
          onClick={() => {
            onClick(link.title, link.url);
          }}
          icon="open_in_new"
        />
      ))}
    </>
  );
};

export const MenuListSubHeader: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <StyledHeader>
      <Typography variant="hint" color={tokens.colorOnSurfaceVariant}>
        {children}
      </Typography>
    </StyledHeader>
  );
};

const StyledLine = styled.div`
  border-top: 1px solid ${tokens.colorSurfaceVariant};
`;
const StyledHeader = styled.div`
  padding: .75rem;
`;
